import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';

export const successRateDetailsOverrideSet = fr.metaOverride({ base: BaseOverrideNoHidden })
  .nameOverride('finicitySuccessfulLinks', { prompt: 'Successful Links' })
  .nameOverride('finicityFailedLinks', { prompt: 'Failed Links' })
  .nameOverride('finicitySuccessRate', { prompt: 'Success Rate' })
  .nameOverride('plaidSuccessfulLinks', { prompt: 'Successful Links' })
  .nameOverride('plaidFailedLinks', { prompt: 'Failed Links' })
  .nameOverride('plaidSuccessRate', { prompt: 'Success Rate' })
  .nameOverride('yodleeSuccessfulLinks', { prompt: 'Successful Links' })
  .nameOverride('yodleeFailedLinks', { prompt: 'Failed Links' })
  .nameOverride('yodleeSuccessRate', { prompt: 'Success Rate' });
